import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Cart from './components/Cart';
import AddedToCartModal from './components/AddedToCartModal';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ProductCatalog from './components/ProductCatalog';
import ProductDetail from './pages/ProductDetail';
import Success from './pages/Success';
import Error from './pages/Error';
import './styles/index.css';

function App() {
  const storeName = process.env.REACT_APP_STORE_NAME || 'Mi Tienda Online';
  const storeDescription = process.env.REACT_APP_STORE_DESCRIPTION || 'Tienda online con catálogo de productos';

  useEffect(() => {
    // Actualizar título
    document.title = storeName;
    
    // Actualizar descripción meta
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', storeDescription);
    }
  }, [storeName, storeDescription]);

  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Cart />
          <AddedToCartModal />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<ProductCatalog />} />
              <Route path="/producto/:id" element={<ProductDetail />} />
              <Route path="/success" element={<Success />} />
              <Route path="/error" element={<Error />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
